import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const ContactPage = () => {
  return <SanityContentPage slug='contact' />
}

export default ContactPage
